import React, { memo } from 'react'
import { Grid } from '@mui/material'
import { faCrown, faUser, faUsers } from '@fortawesome/pro-light-svg-icons'

import Details from './Details'
import RankingsTable from './RankingsTable'
import BaseCard from '../shared/baseCard/BaseCard'

const Leaderboard = ({
  t,
  address,
  leaderboardProfile: { topRankings, communityRankings },
  mainProfile: { rank, points, communityName, communityRank, resultUserDeposit }
}) => {
  const walletHeaders = [
    '',
    '#',
    t('leaderboard.wallet'),
    t('leaderboard.deposit'),
    t('leaderboard.deposit-points')
  ]
  return (
    <Grid container spacing={3} pt={2} pb={3}>
      <Grid item xs={12}>
        <Details
          t={t}
          rankingTable={
            <RankingsTable
              t={t}
              title={t('leaderboard.your-ranking')}
              icon={faUser}
              headers={[
                ...walletHeaders,
                t('leaderboard.your-community'),
                t('leaderboard.ranking-of-your-community')
              ]}
              data={
                address
                  ? [
                      {
                        rank,
                        w: address,
                        e: resultUserDeposit,
                        p: points,
                        additional: {
                          community: communityName,
                          rankOfCommunity: communityRank
                        }
                      }
                    ]
                  : []
              }
              invertBadge
            />
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <BaseCard sx={{ minHeight: 600 }}>
              <RankingsTable
                t={t}
                title={t('leaderboard.top-ranking')}
                icon={faCrown}
                headers={walletHeaders}
                data={topRankings}
                headerKey={t('leaderboard.wallet')}
              />
            </BaseCard>
          </Grid>
          <Grid item xs={12} sm={6}>
            <BaseCard sx={{ minHeight: 600 }}>
              <RankingsTable
                t={t}
                title={t('leaderboard.communities-ranking')}
                icon={faUsers}
                headers={[
                  '',
                  '#',
                  t('leaderboard.community'),
                  t('leaderboard.deposit'),
                  t('leaderboard.deposit-points')
                ]}
                data={communityRankings}
              />
            </BaseCard>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default memo(Leaderboard)
